import { render, staticRenderFns } from "./TextBodySmall2.vue?vue&type=template&id=d68677a4&scoped=true"
import script from "./TextBodySmall2.vue?vue&type=script&lang=js"
export * from "./TextBodySmall2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68677a4",
  null
  
)

export default component.exports